import {
  MAX_NAME_LENGTH,
  MAX_EMAIL_LENGTH,
  MAX_PHONE_LENGTH,
  MAX_ADDRESS_LENGTH,
  MAX_CITY_LENGTH,
  MAX_REGION_LENGTH,
  MAX_ZIP_CODE_LENGTH,
  MAX_TAX_ID_LENGTH,
} from '@/shared/config';
import { InferType, object, string } from '@/shared/config/yup';

export const billingInformationFormSchema = object({
  firstName: string().required().max(MAX_NAME_LENGTH),
  lastName: string().required().max(MAX_NAME_LENGTH),
  phoneNumber: string().required().max(MAX_PHONE_LENGTH),
  email: string().email().required().max(MAX_EMAIL_LENGTH),
  companyName: string().optional().max(MAX_NAME_LENGTH),
  taxID: string().optional().max(MAX_TAX_ID_LENGTH),
  country: string().required(),
  region: string().required().max(MAX_REGION_LENGTH),
  city: string().required().max(MAX_CITY_LENGTH),
  zipCode: string().required().max(MAX_ZIP_CODE_LENGTH),
  address: string().required().max(MAX_ADDRESS_LENGTH),
}).required();

export type BillingInformationFormPayload = InferType<
  typeof billingInformationFormSchema
>;
